// dato color picker works with hex codes, support for a repeated select list doesn't seem to exist
export function getBrandClassFromHex(hex: string): string {
    let name: string = 'primary';

    if (hex) {
        switch (hex?.toLowerCase().replace('#', '')) {
            case '182a54':
                name = 'primary';
                break;
            case '0070b9':
                name = 'secondary';
                break;
            case '364f78':
                name = 'tertiary';
                break;
            case '00a5ab':
                name = 'seafoam';
                break;
            case '4a4a4a':
                name = 'dark-gray';
                break;
            case '696b71':
                name = 'gray';
                break;
            case 'adb0b9':
                name = 'light-gray';
                break;
            case 'c22c38':
                name ='red';
                break;
            case '3ac72d':
                name = 'green';
                break;
            case 'ffa200':
                name = 'yellow';
                break;
        }
    }
    
    return `brand-${name}`;
}